import React from 'react';
import Select, { selectType } from 'Components/Select';
import RowsSelector from 'Components/RowsSelector';

const statuses = [
  { name: 'All', value: 'All' },
  { name: 'Pending', value: 'PENDING' },
  { name: 'Approved', value: 'APPROVED' },
];

export default class FiltersSection extends React.Component {
  getFormattedListForSelect = (nameFieldName, valueFieldName, dataObject, filterFieldName, filterValue) => {
    let formattedList = dataObject.map(entry => ({ name: entry[nameFieldName], value: entry[valueFieldName] }));
    formattedList.sort(({ name: a }, { name: b }) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1));
    formattedList.unshift({ name: 'All', value: 'All' });

    if (filterFieldName) {
      return formattedList.filter(item => item[filterFieldName] === filterValue);
    } else {
      return formattedList;
    }
  };

  _getSelectedItem = (itemValue, itemsList) => {
    const selectedItem = itemsList.find(item => item.value === itemValue);

    if (selectedItem) {
      return selectedItem;
    } else {
      return itemsList[0];
    }
  };

  render() {
    const { handleSelectFilter, filterState, outCount, handleRowsSelect, rowsCount, categories, types } = this.props;

    let categoriesOptions = [];
    let typesOptions = [];

    if (categories.length && types.length) {
      categoriesOptions = this.getFormattedListForSelect('name', 'id', categories);
      typesOptions = filterState.categoryId
        ? this.getFormattedListForSelect(
          'componentTypeName',
          'componentTypeCode',
          categories.find(category => category.id === filterState.categoryId).componentTypes
        )
        : this.getFormattedListForSelect('componentTypeName', 'componentTypeCode', types);
      if (typesOptions.length === 2) typesOptions.shift();
    }

    return (
      <section className='list-scene__utility-section-wrapper'>
        <section className='list-scene__utility-section-filters-wrapper'>
          <div className='list-scene__utility-section-filters-header'>Filter</div>
          <Select
            label='by Category'
            selectionList={categoriesOptions}
            withoutSearch
            defaultItem={this._getSelectedItem(filterState.categoryId, categoriesOptions)}
            itemNameIndicator='name'
            type={selectType.listFilter}
            isLoading={!categoriesOptions.length}
            handleSelect={handleSelectFilter('categoryId')}
          />
          <Select
            label='by Type'
            selectionList={typesOptions}
            withoutSearch
            defaultItem={this._getSelectedItem(filterState.componentType, typesOptions)}
            itemNameIndicator='name'
            type={selectType.listFilter}
            isLoading={!typesOptions.length}
            handleSelect={handleSelectFilter('componentType')}
          />
          <Select
            label='by Status'
            type={selectType.listFilter}
            itemNameIndicator='name'
            withoutSearch
            defaultItem={this._getSelectedItem('status', statuses)}
            placeholder='All'
            selectionList={statuses}
            handleSelect={handleSelectFilter('status')}
          />
        </section>

        <section className='list-scene__utility-section-rows-select-wrapper'>
          <RowsSelector allRowsCount={outCount} handleRowsSelect={handleRowsSelect} selectedRowsCount={rowsCount} />
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/FamilyList/FiltersSection.jsx